import { render, staticRenderFns } from "./CasesModify.vue?vue&type=template&id=413a7dc3&scoped=true&"
import script from "./CasesModify.vue?vue&type=script&lang=js&"
export * from "./CasesModify.vue?vue&type=script&lang=js&"
import style0 from "./CasesModify.vue?vue&type=style&index=0&id=413a7dc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413a7dc3",
  null
  
)

export default component.exports